import { render } from "./MoveBoxOrGrid.vue?vue&type=template&id=45f88819"
import script from "./MoveBoxOrGrid.vue?vue&type=script&lang=js"
export * from "./MoveBoxOrGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__